module.exports = __webpack_public_path__ + "static/media/utkarsh-resume.9be20e0b.pdf";